<template>
  <h1><span class="text-primary">Политика конфиденциальности</span> сайта {{ $domain }}</h1>
  <AppThirdLayout>
    <h2>Сбор информации</h2>
    <p>
      Мы собираем от вас информацию, когда вы заполняете формы на сайте. Собранная информация включает ваше имя,
      адрес электронной почты, номер телефона и другие данные, которые вы указываете при заполнении формы. Кроме того,
      мы
      автоматически получаем и сохраняем информацию с вашего компьютера и браузера, включая ваш IP-адрес, программное
      обеспечение,
      характеристики оборудования и сведения о странице, которую вы запросили для просмотра.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Использование информации</h2>
    <p>
      <strong>Любая информация, которую мы получаем от вас, может быть использована для</strong>:<br>
      • персонализации опыта в соответствии с вашими индивидуальными потребностями.<br>
      • Обеспечения Вам быстрое оформление электронной визы в выбранную вами страну.<br>
      • Предоставления персонализированного маркетингового контента.<br>
      • Улучшения нашего веб-сайта.<br>
      • Улучшения обслуживания и поддержки клиентов.<br>
      • Связи с вами по электронной почте или телефону.<br>
      • Проведения конкурсов, рекламных акций или опросов.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Конфиденциальность электронной торговли</h2>
    <p>
      Мы являемся единственным владельцем информации, представленной на сайте. Информация, по которой вас можно
      идентифицировать
      не подлежит продаже, обмену, передаче какой-либо другой компании по любой причине без вашего согласия, за
      исключением
      информации, необходимой для оформления заявки, например, выдачи электронной визы.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Передача информации третьей стороне</h2>
    <p>
      Мы не продаем, не обмениваем и не передаем каким-либо образом сторонним организациям вашу личную информацию. Этот
      термин не включает квалифицированные сторонние компании, которые помогают нам в работе нашего веб-сайта.
      Мы считаем, что обмен информацией необходим для расследования, предотвращения или принятия мер в связи с
      подозрением в мошенничестве, ситуаций, связанных с возможными угрозами личной безопасности
      любого лица,
      нарушившего наши условия использования или в соответствии с требованиями законодательства. Однако информация неличного
      характера может быть передана внешним
      организациям для маркетинга, рекламы и других целей.<br>В рамках усилий по предоставлению быстрого и дешевого
      обслуживания
      клиентов сайта для оформления въездных виз, личную информацию и реквизиты, включая паспортные данные,
      может быть отправлено третьей стороне, которая занимается выдачей виз, например, официальным государственным органам и
      иммиграционные офисы. Вся передача информации осуществляется безопасным способом после проверки достоверности
      третьей стороной.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Информационная безопасность</h2>
    <p>
      Мы реализуем различные современные меры безопасности для обеспечения безопасности вашей личной информации. Мы
      используем сложное
      шифрование для защиты конфиденциальной информации, передаваемой по сети. Сайт "{{ SITE_NAME }}" также защищает
      вашу информацию в автономном режиме — только сотрудники, которым необходимо выполнять конкретную работу (например,
      информирование клиентов или выдача виз)
      имеют доступ к личной информации. На компьютерах/серверах, используемых для хранения личных данных,
      информация хранится в безопасной среде в соответствии со стандартами SSL и PCI, обновленными для
      {{  getCurrentYear() }}.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Используем ли мы файлы cookie?</h2>
    <p>
      Да. Наши файлы cookie улучшают доступ к нашему веб-сайту и идентифицируют постоянных посетителей. Кроме того, наши
      файлы cookie улучшают
      пользовательский опыт путем отслеживания и ориентации ее/его интересов. Однако использование файлов cookie
      не связано с
      любой личной информацией на нашем сайте.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Удаление из базы данных</h2>
    <p>
      Мы используем предоставленный вами адрес электронной почты для отправки вам информации и обновлений относительно
      вашего заказа, акций,
      новостей, информации о продуктах и т. д.
      Чтобы в дальнейшем не получать письма, прилагаем подробную инструкцию по удалению себя из рассылки
      внизу каждого письма. Кроме того, вы можете в любой момент обратиться к нам с просьбой об удалении, и мы
      выполним
      её в течение трех рабочих дней.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Удаление личного контента с сервера</h2>
    <p>
      Фотографии и/или конфиденциальная информация, которые пользователи сайта загружают на сервер в процессе заполнения
      формы.
      или получения другой услуги, будут удалены вскоре после окончания оказания услуги (например, отправка визы по
      электронной
      почте).
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Соглашение</h2>
    <p>
      Используя наш сайт, вы соглашаетесь с нашей политикой конфиденциальности.
    </p>
  </AppThirdLayout>
</template>

<script setup lang="ts">
import { getCurrentYear } from '~/helpers/date';
import { SITE_NAME } from '~/assets/constants';
</script>